module.exports = __webpack_public_path__ + "static/media/campeonato_05.4c8523f1.jpg";